module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_2.2da45f74.png";